import { render, staticRenderFns } from "./ContactsCard.vue?vue&type=template&id=de751528&"
import script from "./ContactsCard.vue?vue&type=script&lang=js&"
export * from "./ContactsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('de751528')) {
      api.createRecord('de751528', component.options)
    } else {
      api.reload('de751528', component.options)
    }
    module.hot.accept("./ContactsCard.vue?vue&type=template&id=de751528&", function () {
      api.rerender('de751528', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/dashboard/cards/ContactsCard.vue"
export default component.exports